import React from 'react';
import type { JobAd } from '../../../types';
import type { SearchAdHeadingProps } from '../SearchAdHeading';
import { SearchAdHeading } from '../SearchAdHeading';

type JobHeadingProps = {
    ad: JobAd;
    className?: string;
    heading?: (props: SearchAdHeadingProps) => React.ReactElement | null;
};

export function JobHeading(props: JobHeadingProps) {
    const { ad, className, heading } = props;

    const headingText = ad.heading || '\u00A0';
    const headingProps = { className };

    return heading ? (
        heading(headingProps)
    ) : (
        <SearchAdHeading {...headingProps}>{headingText}</SearchAdHeading>
    );
}
